import { Store } from '@ngrx/store';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { combineLatest, from, Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { JwtHelperService } from "@auth0/angular-jwt";
import { AppErrors, NotFoundError, UnauthorizedError } from '@fitness-force/errors';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { LANGUAGE, LoginDataModel, LoginPayload, LoginResponse } from '@fitness-force/models';
import { COMPANY_INFO, TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { environment } from 'apps/ff-frontend/src/environments/environment';

const helper = new JwtHelperService();
@Injectable({
  providedIn: 'root'
})

export class AuthSevices {
  private readonly httpBackend: HttpClient
  constructor(
    private http: HttpClient,
    private router: Router,
    private store: Store,
    private readonly backEndClientHandler: HttpBackend
  ) {
    this.httpBackend = new HttpClient(backEndClientHandler)
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  loginService(logindata: LoginDataModel, BASE_URL: string) {
    return this.httpBackend.post(BASE_URL + CONST_URL_SEGEMENTS.AUTH.LOGIN_TOKEN, logindata, this.httpOptions)
      .pipe(
        map((res: any) => {
          if (res && res.token) {
            localStorage.setItem('token', res.token);
            if (res.refresh_token) {
              localStorage.setItem('refresh_token', res.refresh_token);
            }
            return res;
          }
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          else if (error.status === 401) {
            return throwError(() => new UnauthorizedError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  login(logindata: LoginDataModel): Observable<LoginResponse> {
    this.httpOptions.headers.set('client_id', 'staff-spa');
    return this.httpBackend.post<LoginResponse>(environment.BASE_URL + CONST_URL_SEGEMENTS.AUTH.LOGIN_TOKEN, logindata, this.httpOptions);
  }


  socialLogin(loginData: LoginPayload) {
    this.httpOptions.headers.set('client_id', 'staff-spa');
    return this.httpBackend.post(`${environment.BASE_URL}/external_auth`, loginData,this.httpOptions)
      .pipe(
        map((res: any) => {
          if (res && res.token) {
            localStorage.setItem('token', res.token);
            if (res.refresh_token) {
              localStorage.setItem('refresh_token', res.refresh_token);
            }
            return res;
          }
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          else if (error.status === 401) {
            return throwError(() => new UnauthorizedError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  sendForgotPasswordEmail(uemail: any, BASE_URL: string) {
    return this.http.post(BASE_URL + CONST_URL_SEGEMENTS.AUTH.PASSWORD_LOOKUP, uemail, this.httpOptions)
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          } else {
            return false;
          }
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  sendUniqueIndetifierEmail(identifier: any, userid: number, BASE_URL: string,) {
    return this.http.post(BASE_URL + CONST_URL_SEGEMENTS.AUTH.UNIQUE_IDENTIFIER + userid + '/mail',
      identifier, this.httpOptions)
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          } else {
            return false;
          }
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  validateNewpassword(pass: any, userid: number, BASE_URL: string) {
    return this.http.post(BASE_URL + CONST_URL_SEGEMENTS.AUTH.PASSWORD_RESET + userid + '/password',
      pass, this.httpOptions)
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          } else {
            return false;
          }
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  logout() {
    // Call revoke API before clearing tokens
    this.revokeToken().subscribe({
      next: () => {
        this.clearTokensAndNavigate();
      },
      error: () => {
        // Even if revoke fails, clear tokens and navigate
        this.clearTokensAndNavigate();
      }
    });
  }

  private clearTokensAndNavigate() {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('auth_response');
    this.router.navigate(['/auth/login']);
    // window.location.href = '/auth/login';
  }

  get tokenFromStorage(): string | null {
    return localStorage.getItem('token');
  }

  get refreshTokenFromStorage(): string | null {
    return localStorage.getItem('refresh_token');
  }

  get decodedToken(): any {
    const getToken: any = this.tokenFromStorage;
    return helper.decodeToken(getToken);
  }

  decodedJwtToken(token: string): any {
    return helper.decodeToken(token);
  }



  get selectedLanguageStorage(): string {
    return localStorage.getItem('DEFAULT_LANGUAGE') as string;
  }

  //Need to take decision for storage clear of language
  get selectedLanguage(): LANGUAGE {
    const selectedLang: LANGUAGE = JSON.parse(this.selectedLanguageStorage);
    if (selectedLang && selectedLang.LANG_CODE)
      return JSON.parse(this.selectedLanguageStorage);
    else
      return { COUNTRY: 'India', LANG_ABBRE: 'India', 'LANG_CODE': 'en' } as LANGUAGE
  }

  get parseDecodedToken() {
    const buffDecodedToken = this.decodedToken;
    if (buffDecodedToken && buffDecodedToken.accessed_tenant) {
      const parsedAccessed_tenant = buffDecodedToken.accessed_tenant.split(',');
      const allTenant = buffDecodedToken.all_tenant.split(',');
      buffDecodedToken.accessed_tenant = parsedAccessed_tenant;
      buffDecodedToken.all_tenant = allTenant;
      return buffDecodedToken;
    } else {
      return null
    }
  }



  //this is used to get localized value
  getLocalizedFieldData(primaryData: string, secondaryData: string): Observable<string> {
    return combineLatest([this.store.select(COMPANY_INFO), this.store.select(TENANTS_INFO)]).pipe(
      map(([comp, tent]) => {
        if (comp?.compDetails?.is_secondary_language) {
          if (comp?.selectedLang?.LANG_CODE == tent?.selected_tenant.secondary_language)
            return secondaryData;
          else
            return primaryData;
        }
        else {
          return primaryData;
        }
      })
    )
  }

  get isTokenExpired(): any {
    const getToken: any = this.tokenFromStorage;

    if (!this._isTokenExpired(getToken, (new Date()).getTimezoneOffset() * 60)) {  // this
      return true;

    } else {
      return false;
    }



  }

  get isLoginedIn(): boolean {
    if (this.tokenFromStorage && this.decodedToken && this.isTokenExpired) {
      // this.currentUser;
      return true;
    } else {
      return false;
    }
  }

  get currentUser(): any {
    return this.decodedToken ? this.decodedToken.role : "";
  }

  currentUserDetails(): any {
    return this.decodedToken;
  }

  get loggedInStaffId(): number {
    return parseInt(this.decodedToken.Id);
  }

  get loggedInCompanyId(): number {
    return parseInt(this.decodedToken.companyid);
  }


  private _isTokenExpired(
    token: string | null,
    offsetSeconds?: number
  ): boolean {
    if (!token || token === '') {
      return true;
    }
    const date = helper.getTokenExpirationDate(token);
    offsetSeconds = offsetSeconds || 0;

    if (date === null) {
      return false;
    }
    const currentDate = new Date();
    const localDateModified = currentDate.valueOf() + offsetSeconds;
    //console.log("Toekn expiredate ...localDateModified.",date, currentDate, date.valueOf(),localDateModified,(date.valueOf()-localDateModified))

    return !(date.valueOf() > localDateModified);
  }

  loginWithApple(payload: any, baseUrl: string): Observable<any> {
    return this.http.post(`${baseUrl}/auth/apple`, payload)
      .pipe(
        map((response: any) => {
          if (response.token) {
            localStorage.setItem('token', response.token);
            if (response.refresh_token) {
              localStorage.setItem('refresh_token', response.refresh_token);
            }
          }
          return response;
        })
      );
  }

  loginWithMicrosoft(payload: any, baseUrl: string): Observable<any> {
    return this.http.post(`${baseUrl}/auth/microsoft`, payload)
      .pipe(
        map((response: any) => {
          if (response.token) {
            localStorage.setItem('token', response.token);
            if (response.refresh_token) {
              localStorage.setItem('refresh_token', response.refresh_token);
            }
          }
          return response;
        })
      );
  }

  refreshToken(): Observable<any> {
    const refreshToken = this.refreshTokenFromStorage;
    
    // Enhanced validation
    if (!refreshToken || refreshToken.trim() === '') {
      console.log('🚫 Invalid or missing refresh token');
      return throwError(() => new Error('No refresh token available'));
    }
    
    // Additional validation - check if refresh token looks valid (basic format check)
    if (refreshToken.length < 10) {
      console.log('🚫 Refresh token appears to be invalid (too short)');
      localStorage.removeItem('refresh_token'); // Clean up invalid token
      return throwError(() => new Error('Invalid refresh token format'));
    }

    console.log('🔄 Making refresh token API call');
    const payload = { refresh_token: refreshToken };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'skip': 'true', // Skip interceptor to avoid infinite loop,
      'client_id': 'staff-spa'
    });

    return this.httpBackend.post(environment.BASE_URL + CONST_URL_SEGEMENTS.AUTH.REFRESH_TOKEN, payload, { headers })
      .pipe(
        map((response: any) => {
          if (response && response.token) {
            console.log('✅ Refresh token API successful, updating tokens');
            localStorage.setItem('token', response.token);
            if (response.refresh_token) {
              localStorage.setItem('refresh_token', response.refresh_token);
            }
            return response;
          }
          throw new Error('Invalid refresh token response');
        }),
        catchError((error: any) => {
          console.log('❌ Refresh token API failed:', error);
          
          // If refresh token is invalid/expired, clean it up
          if (error.status === 400 || error.status === 401 || error.status === 403) {
            console.log('🧹 Cleaning up invalid refresh token');
            localStorage.removeItem('refresh_token');
          }
          
          return throwError(() => error);
        })
      );
  }

  revokeToken(): Observable<any> {
    const refreshToken = this.refreshTokenFromStorage;
    if (!refreshToken) {
      return of(null); // No token to revoke, continue with logout
    }

    const payload = { refresh_token: refreshToken };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'skip': 'true', // Skip interceptor to avoid infinite loop
      'client_id': 'staff-spa'
    });

    return this.httpBackend.post(environment.BASE_URL + CONST_URL_SEGEMENTS.AUTH.REVOKE_TOKEN, payload, { headers })
      .pipe(
        catchError((error: any) => {
          // Even if revoke fails, continue with logout
          console.warn('Token revoke failed:', error);
          return of(null);
        })
      );
  }

}
